import { useState, useEffect } from 'react';
import Layout from '../Components/Layout/Layout';
import StatCard from '../Components/Dashboard/StatCard';
import MenuList from '../Components/Dashboard/MenuList';
import ActionButtons from '../Components/Dashboard/ActionButtons';
import { Plus } from "lucide-react";
import { Button } from "@/Components/ui/button";
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../utils/axiosConfig';
import MenuModal from '../Components/Dashboard/MenuModal';
import {
    UtensilsCrossed,
    SquareChartGantt,
    Eye,
    Layers3
} from "lucide-react";

const Dashboard = () => {
    const [menus, setMenus] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [counters, setCounters] = useState({
        categories: 0,
        dishes: 0,
        products: 0
    });
    const [selectedMenu, setSelectedMenu] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const menuId = parseInt(localStorage.getItem('selectedMenu')) || 0;
        setSelectedMenu(menuId);
    }, []);

    useEffect(() => {
        const fetchMenus = async () => {
            try {
                const response = await axiosInstance.get('/menu/GetMenus');
                setMenus(response.data);
            } catch (error) {
                console.error('Error fetching menus:', error);
            }
        };
        fetchMenus();
    }, []);

    const handleMenuSelect = async (menuId) => {
        setSelectedMenu(menuId);
        try {
            const response = await axiosInstance.get('/counter/GetCounters');
            setCounters(response.data);
        } catch (error) {
            console.error('Error updating counters:', error);
        }
    };

    const handleSaveMenu = async (newitem) => {
        try {
            const response = await axiosInstance.post('/menu/AddMenu', {
                id: 0,
                name: newitem.name
            });
            setMenus(prevMenus => [...prevMenus, response.data]);
        } catch (error) {
            console.error('Error saving menu:', error);
        }
    };

    useEffect(() => {
        const fetchCounters = async () => {
            if (selectedMenu === null) return;

            try {
                const response = await axiosInstance.get('/counter/GetCounters');
                setCounters(response.data);
            } catch (error) {
                console.error('Error fetching counters:', error);
            }
        };
        fetchCounters();
    }, [selectedMenu]);

    const stats = [
        {
            title: 'CATEGORIEEN',
            icon: <Layers3 size={45} />,
            count: counters.categories || 0,
            color: 'bg-ps-green',
            path: '/categories'
        },
        {
            title: 'GERECHTEN',
            icon: <UtensilsCrossed size={45} />,
            count: counters.dishes || 0,
            color: 'bg-ps-orange',
            path: '/dishes'
        },
        {
            title: 'PRODUCTEN',
            icon: <SquareChartGantt size={45} />,
            count: counters.products || 0,
            color: 'bg-ps-pink',
            path: '/products'
        },
        {
            title: 'BEKIJK RESULTAAT',
            icon: <Eye size={45} />,
            count: null,
            color: 'bg-ps-blue',
            path: '/result'
        }
    ];

    return (
        <Layout>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8 mt-0 md:mt-[40px]">
                {stats.map((stat) => (
                    <StatCard key={stat.title} {...stat} navigate={navigate} />
                ))}
            </div>
            <MenuList
                menus={menus}
                selectedMenu={selectedMenu}
                onMenuSelect={handleMenuSelect}
            />
            <div className="flex justify-end mt-4">
                <Button
                    onClick={() => setIsModalOpen(true)}
                    className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 bg-ps-green hover:bg-ps-green/90 text-white px-4 py-2 shadow-lg rounded-full"
                >
                    <Plus className="h-6 w-6" />
                    <span>Menukaart toevoegen</span>
                </Button>
                <MenuModal
                    isOpen={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                    onSave={handleSaveMenu}
                />
            </div>
            <ActionButtons />
        </Layout>
    );
};

export default Dashboard;